import { useFgColorValue } from '~theme/fgColor'
import { TContrastLevel } from '~theme/typings'

export type TUseTextPropsOptions = {
  /**
   * number of lines that the text should be cut on (using ... symbol)
   * use 0 for not cutting at all
   */
  truncateOnLines?: number
  /**
   * how contrasted the text should be on said background (might imply significance)
   */
  contrast?: TContrastLevel
}

export const useTextProps = ({
  truncateOnLines = 0,
  contrast = `normal`,
}: TUseTextPropsOptions) => {
  const textColorValue = useFgColorValue({ contrast })
  const isTruncated = truncateOnLines === 1
  const noOfLines = truncateOnLines > 1 ? truncateOnLines : undefined

  return {
    textColorValue,
    isTruncated,
    noOfLines,
  }
}
